import { Link } from 'react-router-dom';
import ExposureResolve from '@/components/base/ExposureResolve';
import Container from '@/components/base/Container';
import Eyebrow from '@/components/base/Eyebrow';
import TitleReveal from '@/components/base/TitleReveal';
import { technicians } from '@/mocks/technicians';

export default function MeetTechnicians() {
  const featured = technicians.slice(0, 3);
  const hasSample = featured.some((t) => t.isSample);

  return (
    <section className="bg-background-50 py-20 md:py-32">
      <Container>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-16">
          <div>
            <Eyebrow label="Our Technicians" />
            <TitleReveal className="mt-6 text-[34px] md:text-[48px] lg:text-[54px] font-medium leading-[1.05] tracking-[-0.025em] text-foreground-950">
              The People Behind Every Visit.
            </TitleReveal>
          </div>
          <div className="flex flex-col items-start justify-end gap-5">
            <p className="max-w-md text-[15px] md:text-base leading-relaxed text-foreground-600">
              Each technician focuses on a group of appliances, so the person at your door already knows the system you rely on.
            </p>
            <Link to="/technicians" className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-foreground-950 mw-link">
              Meet Our Technicians <span className="mw-arrow">&rarr;</span>
            </Link>
          </div>
        </div>

        {hasSample && (
          <p className="mt-10 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs text-accent-900">
            <i className="ri-information-line" />
            Demonstration profiles. Not real MENDWELL staff.
          </p>
        )}

        <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-10">
          {featured.map((t, i) => (
            <Link
              key={t.slug}
              to={`/technicians/${t.slug}`}
              className={`group block ${i === 2 ? 'sm:hidden lg:block' : ''}`}
            >
              <ExposureResolve className="h-[380px] md:h-[440px] w-full overflow-hidden rounded-xl bg-primary-50">
                <img
                  src={t.portrait}
                  width={800}
                  height={1000}
                  loading="lazy"
                  decoding="async"
                  alt={`${t.name}, ${t.role}`}
                  title={`${t.name} - MENDWELL appliance repair`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.02]"
                />
              </ExposureResolve>
              <div className="flex items-end justify-between gap-4 border-b border-background-200 py-5">
                <div className="min-w-0">
                  <p className="text-[11px] uppercase tracking-[0.16em] text-primary-600">{t.role}</p>
                  <h3 className="mt-2 text-lg md:text-xl font-medium tracking-tight text-foreground-950">{t.name}</h3>
                </div>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-background-200 text-primary-600 transition-colors group-hover:border-primary-500 group-hover:bg-primary-500 group-hover:text-white">
                  <i className="ri-arrow-right-up-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
}